import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Hotel, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      toast.success('Login berhasil');
      navigate('/');
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-background flex">
      {/* Left side - Login form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center">
                <Hotel className="w-6 h-6 text-primary-foreground" />
              </div>
              <div>
                <h1 className="text-2xl font-semibold tracking-tight">HotelDesk</h1>
                <p className="text-sm text-muted-foreground">Sistem Ticketing Internal</p>
              </div>
            </div>
            <h2 className="text-3xl font-medium tracking-tight mb-2">Selamat Datang Kembali</h2>
            <p className="text-muted-foreground">Masuk ke akun Anda untuk melanjutkan</p>
          </div>

          <Card className="border-border shadow-none">
            <CardContent className="pt-6">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="admin@hotel.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    data-testid="login-email-input"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="password">Password</Label>
                  <Input
                    id="password"
                    type="password"
                    placeholder="Masukkan password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    data-testid="login-password-input"
                  />
                </div>
                <Button
                  type="submit"
                  className="w-full bg-primary hover:bg-primary/90"
                  disabled={loading}
                  data-testid="login-submit-button"
                >
                  {loading ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Memproses...
                    </>
                  ) : (
                    'Masuk'
                  )}
                </Button>
              </form>
            </CardContent>
          </Card>

          {process.env.REACT_APP_SHOW_DEMO === 'true' && (
            <div className="mt-6 p-4 rounded-lg bg-muted/50 border border-border" data-testid="demo-credentials-box">
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">Akun Demo</p>
              <p className="text-sm">Email: <span className="font-mono">admin@hotel.com</span></p>
              <p className="text-sm">Password: <span className="font-mono">admin123</span></p>
            </div>
          )}
        </div>
      </div>

      {/* Right side - Hero image */}
      <div className="hidden lg:flex flex-1 relative overflow-hidden bg-foreground">
        <img
          src="https://customer-assets-jai6qajn.emergentagent.net/job_ticket-invoice-1/artifacts/eujsdej0_PJP-900X800-7.jpg"
          alt="LeGreen Suite Senayan"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="relative z-10 flex flex-col justify-end p-12 text-white bg-gradient-to-t from-black/70 to-transparent">
          <h3 className="text-4xl font-medium tracking-tight mb-4">
            Kelola Operasional Hotel Anda dengan Mudah
          </h3>
          <p className="text-lg text-white/80 max-w-md">
            Platform terintegrasi untuk manajemen tiket, inventory, dan operasional multi-cabang.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
